import { COLORS, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledSettingsCard = styled.div`
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledPageTitle = styled.h1`
  ${pickThemeFontStyles('28', '32', 'BOLD')};
  color: ${COLORS.DARK_PURPLE};
  margin: 0;
`;
